<template>
  <input
    v-model="approveCode"
    :min="0"
    :max="999999"
    type="number"
    class="input-code"
    id="code"
  />
</template>

<script>
export default {
  name: "CodeConfirmationInput",
  data() {
    return {
      approveCode: "",
    };
  },
  mounted() {
    document.getElementById("code").oninput = function() {
      if (this.value.length > 5) {
        this.value = this.value.slice(0, 5);
      }
    };
  },
  watch: {
    approveCode() {
      if (this.approveCode.length == 5) {
        this.$emit("codeChanged", this.approveCode);
      }
    },
  },
};
</script>

<style scoped>
.input-code {
  display: block;
  width: 100%;
  border: none;
  background: #f5f5f6;
  border-radius: 5px;
  text-align: center !important;
  height: 40px;
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
}
.input-code:focus {
  outline: none;
}
.sms-confirmation {
  width: 40px;
  margin-right: 10px;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none !important;
  margin: 0 !important;
}
</style>
